const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogAcompanhamentoTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAcompanhamentoTurma`, params);
    },
    $obterRelatorioLogCSVAcompanhamentoTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAcompanhamentoTurmaCsv`, params);
    },
    $obterRelatorioLogPDFAcompanhamentoTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAcompanhamentoTurmaPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
